var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import styles from './MarkdownViewer.module.scss';
var colorStyleOnly = /^color\s*:\s*(?:#[0-9a-f]{3,8}|[a-z]+|rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)|rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(?:0|1|0?\.\d+)\s*\)|hsl\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*\)|hsla\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*,\s*(?:0|1|0?\.\d+)\s*\))\s*;?$/i;
export var MarkdownViewer = function (_a) {
    var value = _a.value, className = _a.className, components = _a.components, _b = _a.allowHtml, allowHtml = _b === void 0 ? true : _b, _c = _a.allowColorSpan, allowColorSpan = _c === void 0 ? true : _c, remarkPlugins = _a.remarkPlugins, rehypePlugins = _a.rehypePlugins;
    var sanitizeSchema = useMemo(function () {
        var _a;
        if (!allowColorSpan)
            return defaultSchema;
        return __assign(__assign({}, defaultSchema), { attributes: __assign(__assign({}, defaultSchema.attributes), { span: __spreadArray(__spreadArray([], (((_a = defaultSchema.attributes) === null || _a === void 0 ? void 0 : _a.span) || []), true), [['style', colorStyleOnly]], false) }) });
    }, [allowColorSpan]);
    var baseRehype = useMemo(function () {
        var list = [];
        if (allowHtml)
            list.push(rehypeRaw);
        list.push([rehypeSanitize, sanitizeSchema]);
        return list;
    }, [allowHtml, sanitizeSchema]);
    var mergedComponents = useMemo(function () {
        var defaults = {
            a: function (_a) {
                var children = _a.children, href = _a.href;
                return (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer", className: styles.link }, children));
            }
        };
        return __assign(__assign({}, defaults), (components || {}));
    }, [components]);
    return (React.createElement(ReactMarkdown, { className: "".concat(styles.markdown, " ").concat(className || ''), components: mergedComponents, remarkPlugins: remarkPlugins, rehypePlugins: __spreadArray(__spreadArray([], baseRehype, true), (rehypePlugins || []), true) }, value !== null && value !== void 0 ? value : ''));
};
